import { render, staticRenderFns } from "./searchCom.vue?vue&type=template&id=46530c73&scoped=true"
import script from "./searchCom.vue?vue&type=script&lang=js"
export * from "./searchCom.vue?vue&type=script&lang=js"
import style0 from "./searchCom.vue?vue&type=style&index=0&id=46530c73&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46530c73",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46530c73')) {
      api.createRecord('46530c73', component.options)
    } else {
      api.reload('46530c73', component.options)
    }
    module.hot.accept("./searchCom.vue?vue&type=template&id=46530c73&scoped=true", function () {
      api.rerender('46530c73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fixDutyFine/LMLiabilityForLosses/cmp/searchCom.vue"
export default component.exports